/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetIndividualLicense = require('../services/GetIndividualLicense');
var GetIndividual = require('../../individual-dashboard/services/GetIndividual');
var GetIndividualLicenseIdentifiers = require('../services/GetIndividualLicenseIdentifiers');
var SecIntIndividualLicenseDashboardView = require('../views/SecIntIndividualLicenseDashboardView');

module.exports = function(individualId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetIndividualLicense(licenseId), GetIndividual(individualId), GetIndividualLicenseIdentifiers(licenseId))
    .done(function(license, individual, identifiers) {
      Scaffold.content.show(
        new SecIntIndividualLicenseDashboardView({
          viewMode: 'int',
          objectTypeId: 'IND-LICENSE',
          model: new Backbone.Model({
            individualId: individualId,
            licenseId: licenseId,
            identifiers: identifiers,
            individual: individual,
            license: license
          })
        })
      );
      NavUtils.navigate('#sec/individual/' + individualId + '/license/' + licenseId + '/dashboard');
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
